'use client'

import { ForwardedRef, forwardRef } from "react"

import { useRouter } from 'next/navigation'

import { locales } from '@/i18n'

import Dropdown, { DropdownItem }  from '@/components/Dropdown'
import Link from "@/components/Link"
import Typography, { TypographyColor } from '@/components/Typography'

import { useTranslations } from '@/hooks/useTranslations'

export type WithLocaleProps = {
    locale: string
}

const LanguageSwitcher = ({ locale }: WithLocaleProps) => {

    const router = useRouter()

    const rest = locales.filter((lang) => lang !== locale)

    function onClick (event: any, lang: string) {
        event.preventDefault()
        event.stopPropagation()
        router.push('/' + lang + '/')
    }

    return (
        <Dropdown color="dark" label={<LanguageCurrent locale={locale} color="light" />} arrowIcon={false} theme={dropdownTheme}>
        {rest.map((lang) => (
            <div onClick={(event: any) => onClick(event, lang)} key={lang} >
                <DropdownItem href={`${process.env.NEXT_PUBLIC_DOMAIN}/${lang}/`} disabled={true}>
                    <LanguageCurrent locale={lang} color="dark" />
                </DropdownItem>
            </div>
        ))}
        </Dropdown>
      );

}

const LanguageCurrent = forwardRef(({ locale, color }: WithLocaleProps & { color: TypographyColor}, ref: ForwardedRef<any>) => {

    const t = useTranslations('locales');

    return (
        <div className="flex gap-3 items-center cursor-pointer justify-start mr-auto px-2" ref={ref}>
            <svg className="w-4 h-4">
                <use xlinkHref={`/icons-sprite.svg#${mapLocaleToFlag(locale)}`}></use>
            </svg>
            <Typography variant="span" className="md:block" color={color}>
                {t(locale)}
            </Typography>
        </div>
    )
})

function mapLocaleToFlag (locale: string) {
    switch (locale) {
        case 'pl': {
            return 'flag_default'
        }
        case 'en': {
            return 'flag_eu'
        }
        case 'cz': {
            return 'flag_cz'
        }
        case 'de': {
            return 'flag_de'
        }
        case 'fr': {
            return 'flag_fr'
        }
        case 'ro': {
            return 'flag_ro'
        }
        case 'sk': {
            return 'flag_sk'
        }
        case 'it': {
            return 'flag_it'
        }
        default: {
            return 'flag_eu'
        }
    }
}

const dropdownTheme = {
  "arrowIcon": "ml-2 h-4 w-4",
  "content": "py-1 focus:outline-none",
  "floating": {
    "animation": "transition-opacity",
    "base": "z-10 w-fit divide-y divide-gray-100 shadow focus:outline-none",
    "content": "py-1 text-sm text-gray-700 dark:text-gray-200",
    "divider": "my-1 h-px bg-gray-100 dark:bg-gray-600",
    "header": "block px-4 py-2 text-sm text-gray-700 dark:text-gray-200",
    "hidden": "invisible opacity-0",
    "target": "rounded-none	md:w-[220px] justify-start p-0 bg-[#2b2b2b] enabled:hover:bg-[#2b2b2b] -ml-6 focus:ring-[#2b2b2b]"
  },
}


export default LanguageSwitcher